import { API_INSTANCE, fullBuildURL } from 'src/features/utils';
import axios from 'axios';
import { API_URL } from 'src/utils/transport';
import * as T from './types';

export const fetchWidgetDataApi = async (payload: T.FetchWidgetApiPayload) => {
  return API_INSTANCE.get(
    fullBuildURL(`/api/v1/dashboard/sites/${payload.siteId}/widgets/${payload.widgetId}`),
  );
};

export const fetchWidgetsApi = async (payload: T.FetchWidgetsApiPayload) => {
  const response = await API_INSTANCE.get(
    fullBuildURL(`/api/v1/dashboard/sites/${payload.siteId}/widgets`),
  );
  return response.data;
};

export const createWidgetApi = async (payload: T.CreateWidgetPayload) => {
  const requestBody: { name: string; is_default?: boolean } = { name: payload.name };
  if (payload.is_default !== undefined) {
    requestBody.is_default = payload.is_default;
  }

  const response = await API_INSTANCE.post(
    fullBuildURL(`/api/v1/dashboard/sites/${payload.siteId}/widgets`),
    requestBody,
  );

  // Select the newly created widget
  await axios.post(
    `${API_URL}/api/v1/accounts/select-widget`,
    { widget_id: response.data.id },
    {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return response.data;
};

export const updateWidgetApi = async (payload: T.UpdateWidgetPayload) => {
  const requestBody: { name: string; is_default?: boolean } = { name: payload.name };
  if (payload.is_default !== undefined) {
    requestBody.is_default = payload.is_default;
  }

  const response = await API_INSTANCE.put(
    fullBuildURL(`/api/v1/dashboard/sites/${payload.siteId}/widgets/${payload.widgetId}`),
    requestBody,
  );

  return response.data;
};

export const deleteWidgetApi = async (payload: T.DeleteWidgetPayload) => {
  return API_INSTANCE.delete(
    fullBuildURL(`/api/v1/dashboard/sites/${payload.siteId}/widgets/${payload.widgetId}`),
  );
};

export const duplicateWidgetApi = async (payload: T.DuplicateWidgetPayload) => {
  const response = await API_INSTANCE.post(
    fullBuildURL(`/api/v1/dashboard/sites/${payload.siteId}/widgets/${payload.widgetId}/duplicate`),
    { name: payload.name },
  );

  // Select the newly duplicated widget
  await axios.post(
    `${API_URL}/api/v1/accounts/select-widget`,
    { widget_id: response.data.widget.id },
    {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return response.data;
};
